import { useState } from "react";
import { memes, memeCategories } from "@/mocks/chiagua";

export default function Memes() {
  const [cat, setCat] = useState("全部");
  const [active, setActive] = useState<(typeof memes)[number] | null>(null);
  const [copied, setCopied] = useState(false);

  const list = cat === "全部" ? memes : memes.filter((m) => m.category === cat);

  const copyLink = async (url: string) => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      /* 兼容性兜底 */
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <section id="memes" className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="font-heading text-2xl text-primary-500 md:text-3xl">🎨 梗图素材库</p>
          <h2 className="mt-2 text-2xl font-black text-foreground-950 md:text-4xl">高清吃瓜梗图 · 表情包任你挑</h2>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            沙雕动物、打工人、躺平文学……想要的表情包大户和上头梗都给你整理好了，点开即可收藏使用。
          </p>
        </div>
      </div>

      {/* 分类筛选 */}
      <div className="mt-6 flex gap-2 overflow-x-auto pb-1 no-scrollbar md:flex-wrap">
        {memeCategories.map((c) => (
          <button
            key={c}
            type="button"
            onClick={() => setCat(c)}
            className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
              cat === c ? "bg-accent-500 text-background-50" : "bg-background-100 text-foreground-700 hover:bg-background-200"
            }`}
          >
            {c}
          </button>
        ))}
      </div>

      <div className="mt-7 grid grid-cols-2 gap-4 md:gap-6 lg:grid-cols-4">
        {list.map((m) => (
          <button
            key={m.id}
            type="button"
            onClick={() => setActive(m)}
            className="group relative overflow-hidden rounded-2xl bg-background-100 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400"
          >
            <div className="aspect-square w-full overflow-hidden">
              <img
                src={m.img}
                alt={`吃瓜梗图素材：${m.title}`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            {m.hot && (
              <span className="absolute left-2.5 top-2.5 inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-bold text-background-50">
                <i className="ri-fire-fill" aria-hidden="true"></i> 热梗
              </span>
            )}
            <div className="p-3 md:p-4">
              <span className="rounded-md bg-background-200 px-2 py-0.5 text-xs text-foreground-600">{m.category}</span>
              <h3 className="mt-2 truncate text-sm font-bold text-foreground-950 md:text-base">{m.title}</h3>
              <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500">{m.desc}</p>
            </div>
            <span className="absolute inset-0 flex items-center justify-center bg-foreground-950/0 transition-colors duration-300 group-hover:bg-foreground-950/20">
              <span className="translate-y-2 rounded-full bg-background-50 px-4 py-2 text-sm font-bold text-foreground-900 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                点击预览
              </span>
            </span>
          </button>
        ))}
      </div>

      {/* 预览弹窗 */}
      {active && (
        <div
          className="fixed inset-0 z-[60] flex items-center justify-center bg-foreground-950/70 p-4 backdrop-blur-sm"
          role="dialog"
          aria-modal="true"
          aria-label={`预览梗图：${active.title}`}
          onClick={() => setActive(null)}
        >
          <div
            className="w-full max-w-md animate-pop overflow-hidden rounded-3xl bg-background-50"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative">
              <img src={active.img} alt={`吃瓜梗图素材：${active.title}`} className="h-64 w-full object-cover object-top md:h-72" />
              <button
                type="button"
                aria-label="关闭预览"
                onClick={() => setActive(null)}
                className="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full bg-foreground-950/60 text-background-50 backdrop-blur-sm transition-colors hover:bg-primary-500"
              >
                <i className="ri-close-line text-lg" aria-hidden="true"></i>
              </button>
            </div>
            <div className="p-5">
              <span className="rounded-md bg-background-200 px-2 py-0.5 text-xs text-foreground-600">{active.category}</span>
              <h3 className="mt-2 text-lg font-black text-foreground-950">{active.title}</h3>
              <p className="mt-1 text-sm text-foreground-600">{active.desc}</p>
              <div className="mt-4 flex gap-2">
                <button
                  type="button"
                  onClick={() => copyLink(active.img)}
                  className="inline-flex flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className={copied ? "ri-check-line" : "ri-link" + ""} aria-hidden="true"></i>
                  {copied ? "素材链接已复制" : "复制素材链接"}
                </button>
                <a
                  href="#contact"
                  onClick={() => setActive(null)}
                  className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-background-200 px-4 py-2.5 text-sm font-bold text-foreground-800 transition-colors hover:bg-background-300"
                >
                  想要更高清
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}